import Enum from './enum'

class QuestionType extends Enum {
    static SELECT = 1; // 選択式
    static INPUT_REQUIRED = 2; // 自由記述式（必須回答）
    static INPUT_NULLABLE = 21; // 自由記述式（任意回答）
    static IMAGE = 3; // 画像
    static ICON_TWO = 4; // 絵文字2択
    static ICON_THREE = 5; // 絵文字3択

    static values() {
        return {
            [this.SELECT]: '選択式',
            [this.INPUT_REQUIRED]: '自由記述式（必須回答）',
            [this.INPUT_NULLABLE]: '自由記述式（任意回答）',
            [this.IMAGE]: '画像',
            [this.ICON_TWO]: '絵文字2択',
            [this.ICON_THREE]: '絵文字3択',
        }
    }
}

export default QuestionType;
